import { GET } from "../adapters/xhr";

export default function (vesselName, duplicateVesselMmsiNumbers) {
    return (dispatch) => {

        const url = "api/Vessel/SendDuplicateVesselEmail";
        const params = {
            vesselName,
            duplicateVesselMmsiNumbers
        };

        GET(url, params)
            .catch(function (response) {

            });
    };
}